import { Divider } from "@tokenterminal/core/ui/layout/divider/Divider"
import type { ReactNode } from "react"
import NavGetListed from "@/components/common/NavGetListed"
import { AppsNavVisual, ChainsNavVisual } from "@/components/common/NavGetListedVisuals"
import NavProducts from "@/components/common/NavProducts"
import { SublinkItem } from "@/components/common/SublinkItem"
import { products } from "./content"

type NavLink = {
  label: string
  href: string
  sublinks?: NavLink[]
  renderDesktopSublinks?: () => ReactNode
}

const largeProductIds = ["explorer", "studio"]
const coreProductIds = ["mcp", "sheets", "api", "datashare"]
const partnershipProductIds = ["data-partnerships", "integrations", "indexes", "research"]

const largeProductsToShow = products.filter((product) => largeProductIds.includes(product.id))
const coreProductsToShow = products.filter((product) => coreProductIds.includes(product.id))
const partnershipProductsToShow = products.filter((product) =>
  partnershipProductIds.includes(product.id),
)

const getListedItems = [
  {
    name: "Apps",
    href: "/get-listed/apps",
    subheading: "Your project powered by our platform",
    navVisual: () => <AppsNavVisual />,
  },
  {
    name: "Chains",
    href: "/get-listed/chains",
    subheading: "Your ecosystem, standardized",
    navVisual: () => <ChainsNavVisual />,
  },
]

export const navLinks: NavLink[] = [
  {
    label: "Products",
    href: "/products",
    sublinks: products.map((product) => ({
      label: product.name,
      href: product.ctaHref,
    })),
    renderDesktopSublinks: () => (
      <div className="flex items-start gap-2">
        <NavProducts products={largeProductsToShow} />
        <Divider orientation="vertical" />
        <div className="flex flex-col gap-px">
          {coreProductsToShow.map((product) => (
            <SublinkItem
              key={product.id}
              href={product.ctaHref}
              label={product.name}
              icon={product.icon}
              showArrow={true}
            />
          ))}
        </div>
        <Divider orientation="vertical" />
        <div className="flex flex-col gap-px">
          {partnershipProductsToShow.map((product) => (
            <SublinkItem
              key={product.id}
              href={product.ctaHref}
              label={product.name}
              icon={product.icon}
              showArrow={true}
            />
          ))}
        </div>
      </div>
    ),
  },
  {
    label: "Get Listed",
    href: "/get-listed",
    sublinks: [
      {
        label: "Apps",
        href: "/get-listed/apps",
      },
      {
        label: "Chains",
        href: "/get-listed/chains",
      },
    ],
    renderDesktopSublinks: () => (
      <div className="flex items-start gap-2">
        <NavGetListed items={getListedItems} />
      </div>
    ),
  },
  {
    label: "Pricing",
    href: "/pricing",
  },
  {
    label: "Resources",
    href: "/resources",
  },
  {
    label: "About",
    href: "/about",
  },
]
